import { gql } from 'apollo-angular';

export const PRODUCT_SELECTOR_VARIABLES_FRAGMENT = gql`
  fragment ProductSelectorVariablesFragment on ConfigurationSection {
    variables: filteredVariables(paging: {page: 0, perPage: 250}, filter: {isVisible: true}) {
      items {
        id
        name
        values {
          name
          value
          assigned
          incompatible
          image: property(name: "Image") {
            valueText
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
